module.exports = __webpack_public_path__ + "static/media/services2.32df544c.mp4";